import { Tooltip } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { AlarmActive, CampaignHistoryMsgIcon, CampaignHistoryMsgIconHover } from '../../icon';
import { ConversationCardModel } from '../../models/conversations';

interface MessageScheduleInfoProps {
    scheduleIcon: boolean;
    selectedScheduleType: number;
    scheduleTypes: { Name: string; Value: number }[];
    scheduleDateTime: number | string;
    onScheduleTypeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onShowCalendarClick: () => void;
    campaignId: string;
    handlePopoverOpen: (event: any) => void;
    getCampaignMessageReport: (id: string) => void;
    conversationAuditId: string;
    CardData: ConversationCardModel;
    onclick: () => void;
}

const MessageScheduleInfo: React.FC<MessageScheduleInfoProps> = ({
    scheduleIcon,
    selectedScheduleType,
    scheduleTypes,
    scheduleDateTime,
    onScheduleTypeChange,
    onShowCalendarClick,
    campaignId,
    handlePopoverOpen,
    getCampaignMessageReport,
    conversationAuditId,
    CardData,
    onclick,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const iconContainerRef = useRef<HTMLDivElement>(null);

    const handleIconClick = (e: any) => {
        if (!!CardData?.Campaign?.ID) {
            handlePopoverOpen(e);
            getCampaignMessageReport(conversationAuditId);
            setIsPopupVisible(true);
        }
    };

    const handleOutsideClick = (event: MouseEvent) => {
        if (iconContainerRef.current && !iconContainerRef.current.contains(event.target as Node)) {
            setIsPopupVisible(false);
        }
    };

    useEffect(() => {
        if (isPopupVisible) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [isPopupVisible]);

    return (
        <div className='d-flex justify-between align-center'>
            <div>
                {/* {scheduleIcon && (
                    <div className={`d-flex bg-color-secondary br-5 h-3 justify-center align-center my-auto float-right`}
                        onClick={onclick}
                    >
                        <select
                            className='h6-regular px-1'
                            style={{
                                border: 'none',
                                backgroundColor: 'transparent',
                                textAlign: 'center',
                                color: 'black',
                                opacity: '1',
                                appearance: 'none',
                            }}
                            value={selectedScheduleType}
                            onChange={onScheduleTypeChange}
                            disabled
                        >
                            {scheduleTypes.map(option => (
                                <option key={option.Value} value={option.Value}>
                                    {option.Name}
                                </option>
                            ))}
                        </select>
                        <div className='schedule-selected-verticle'></div>
                        <div onClick={onShowCalendarClick} className='h6-regular t-align-left ml-1'>
                            {scheduleDateTime !== -1 ? moment(scheduleDateTime).format('MMMM Do YYYY HH:mm') : 'MM DD YYYY HH'}
                        </div>
                        <div style={{ marginTop: '4px' }}>
                            <Tooltip title='Schedule Later' placement='bottom'>
                                <AlarmActive className={`c-pointer px-1`} />
                            </Tooltip>
                        </div>
                    </div>
                )} */}
            </div>
            {campaignId && (
                <div
                    ref={iconContainerRef}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={handleIconClick}
                    className='icon-container ml-1 c-pointer'
                >
                    <Tooltip title={!!CardData?.Campaign ? 'Click on this icon to see message status' : 'Broadcast Message'} placement='bottom'>
                        {isHovered || isPopupVisible ? <CampaignHistoryMsgIconHover /> : <CampaignHistoryMsgIcon />}
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export default MessageScheduleInfo;
